Auth = require 'db/auth'
Storage = require 'lib/storage'
View = require 'view'
templates = require 'views/internal/templates'
trackUe = require 'debug/trackUe'

module.exports = class HeaderBackButtonView extends View

  className: 'header-back-button'

  events:
    'click .js-back-menu': 'backPressed'

  render: ->

    @$el.html(
      templates.fill(
        'header_back_menu_button'
      )
    )

    @

  backPressed: ->
    cachedRoute = Storage.get("home_#{Auth.me().id}_last_tab_2")
    tab = ''
    if cachedRoute == '/'
      tab = 'home'
    else if cachedRoute?.endsWith('/boards')
      tab = 'boards'
    else if cachedRoute?.endsWith('/home') || cachedRoute?.endsWith('/highlights') || cachedRoute?.contains('/cards/')
      tab = 'team'

    category = 'header'
    verb = 'opens'
    direct_obj = 'landing tab'
    indirect_object = ''
    prepositional_object = ''
    method = 'by clicking home icon'
    context = { landingtab: tab }

    trackUe(category, verb, direct_obj, indirect_object, prepositional_object, method, context)



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-back-button-view.coffee